import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppService } from '../app.service';
import { AutenticacaoService } from '../autenticacao/autenticacao.service';

@Injectable()
export class AutenticacaoHttpInterceptor implements HttpInterceptor {
  constructor(private autenticacaoService: AutenticacaoService, private appService: AppService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.startsWith(this.appService.configs.paths.base) && this.autenticacaoService.isAutenticado()) {
      const requestAlterado = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.autenticacaoService.getUsuarioSessao().token}`,
        },
      });

      return next.handle(requestAlterado);
    } else {
      return next.handle(request);
    }
  }
}
